module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"value":"Zählerstand","cumulative":"Kumuliert"},"en":{"value":"Value","cumulative":"Cumulative"}}')
  delete Component.options._Ctor
}
